module.exports = __webpack_public_path__ + "img/logo-loverfans-black.89f23f97.svg";